import { isEmptyObject } from '../../core/util';

export const states = [
  'AA',
  'AE',
  'AP',
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

export const parsePhoneForDisplay = (phones, phoneNumberType) => {
  if (!isEmptyObject(phones) && phones.length > 0) {
    const phoneForParsing = phones.filter(num => num.type === phoneNumberType);
    if (!isEmptyObject(phoneForParsing) && phoneForParsing.length) {
      const {
        areaCode = '',
        exchange = '',
        lastFour = ''
      } = phoneForParsing[0];
      return [areaCode, exchange, lastFour].filter(Boolean)
        ? `(${areaCode}) ${exchange}-${lastFour}`
        : '';
    }
  }

  return '';
};

export const getDefaultMobilePhone = phones =>
  parsePhoneForDisplay(phones, 'MOBILE') ||
  parsePhoneForDisplay(phones, 'DAYTIME') ||
  parsePhoneForDisplay(phones, 'EVENING');
